import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { BsThreeDotsVertical } from "react-icons/bs";
import sha1 from 'crypto';
import './styles.css';

export default function Navperfil() {
  const BASE_URL = sessionStorage.getItem('BASE_URL');
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const history = useHistory();
  const { t } = useTranslation();

  const hash = sha1.createHmac('sha256', USER_EMAIL)
    .update(USER_EMAIL)
    .digest('hex');

  const USER_TOKEN_TEMP = hash;

  function tokenTemporario() {
    let tmpToken = "";
    var axios = require('axios');
    var FormData = require('form-data');
    var data = new FormData();
    data.append('USER_TOKEN', USER_TOKEN_TEMP);
    data.append('USER_EMAIL', USER_TOKEN);

    var config = {
      method: 'post',
      url: BASE_URL + '/v2/users/me/temporary_token',
      headers: {
        'USER_TOKEN': USER_TOKEN,
        'USER_EMAIL': USER_EMAIL,
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        tmpToken = response.data.token;
        const urlToken = BASE_URL + '/users/me/subscriptions/me?token=' + tmpToken;
        sessionStorage.setItem('urlToken', urlToken)
      })
      .catch(function (error) {
      });

  }
  tokenTemporario();
  function abreURL() {
    window.open(sessionStorage.getItem('urlToken'), '_blank')
  }


  function abriFechaMenu() {
    var el = document.querySelector('#menuPerfil');
    if (el.style.display === 'block') {
      el.style.display = 'none';
    } else {
      el.style.display = 'block';
    }
  }

  function cancelarPlano() {
    var axios = require('axios');
    //var FormData = require('form-data');
    //var data = new FormData();

    var config = {
      method: 'post',
      url: BASE_URL + '/v2/users/me/cancel_subscription',
      //url: 'staging.agrobrazilapp.com/v1/users/me/cancel_subscription',
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,
        //  ...data.getHeaders()
      },
      //data: data
    };

    axios(config)
      .then(function (response) {
        var mensagem = document.getElementById('mensagens');
        mensagem.style.display = 'block';
        mensagem.classList.replace('erro', 'certo');
        document.getElementById("mensagens").innerHTML = t('pages.includes.profileMenu.cancelMessage');
        setTimeout(() => {
          document.getElementById("mensagens").innerHTML = "";
          document.getElementById("mensagens").style.display = 'none';
        }, 5000);
      })
      .catch(function (error) {
      });
  }

  function logoff() {
    history.push('/');
    // var axios = require('axios');
    // var data = '';

    // var config = {
    //   method: 'delete',
    //   url: BASE_URL + '/v2/users/sign_out',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'USER_EMAIL': USER_EMAIL,
    //     'USER_TOKEN': USER_TOKEN
    //   },
    //   data: data
    // };

    // axios(config)
    //   .then(function (response) {
    //   })
    //   .catch(function (error) {
    //   });

  }

  return (
    <div className="navPerfil">
      <div>
        <BsThreeDotsVertical onClick={() => abriFechaMenu()} className="iconMenu" />
      </div>
      <div className="menuPerfil" id="menuPerfil">
        <ul>
          <li>
            <Link to="/user/edit/">
              {t('pages.includes.profileMenu.informations')}
            </Link>
          </li>
          <li>
            <Link to="/user/interesses">
              {t('pages.includes.profileMenu.interests')}
            </Link>
          </li>
          <li>
            <Link to="/user/alterar/senha">
              {t('pages.includes.profileMenu.password')} 
            </Link>
          </li>
          <li>
            <Link to="#" onClick={() => abreURL()}>
              {t('pages.includes.profileMenu.updatePlan')}
            </Link>
          </li>
          <li>
            <Link to="#" onClick={() => cancelarPlano()}>
              {t('pages.includes.profileMenu.cancelPlan')}
            </Link>
          </li>
          <li>
            <Link to="/sobre">
              {t('pages.includes.profileMenu.about')}
            </Link>
          </li>
          <li>
            <Link to="#" onClick={() => logoff()}>
              {t('pages.includes.profileMenu.logoff')}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  )
}
